// Shared Swiper configurations
// This file provides consistent swiper settings for both global Swiper instances and Vue components

export const allOddsSwiperConfig = {
  slidesPerView: 3,
  spaceBetween: 5,
  pagination: {
    el: ".all-m-odds-swiper .swiper-pagination",
    clickable: true
  },
  breakpoints: {
    768: {
      slidesPerView: 5,
      spaceBetween: 10
    }
  }
};

export default {
  allOddsSwiperConfig
};

